import { useDispatch, useSelector } from "react-redux"
import About from "../components/research/irmc/about"
import Research from "../components/research/irmc/research"
import Pages from "../components/research/pages"
import { useEffect } from "react"
import { fetchResearchData } from "../redux/slice/researchPage"
import { retrunAssets } from "../utils/getAssets"
import { fetchResearchPagesData } from "../redux/slice/researchPages"
import Content from "../components/research/irmc/content"
import { useParams } from "react-router-dom"
const Irmc = () => {


    const { name } = useParams()
    const state = useSelector(state => state.researchPages)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchResearchPagesData(name))
    }, [name])



    const research = state?.data?.properties







    const text = research?.title
    const bg = research?.backgroundImage != null ? retrunAssets(research?.backgroundImage[0].url) : ""

    const data = research?.content?.map(item => {
        return item?.properties
    }).filter(item => item?.title?.toLowerCase() != "contact us")

    const contactUs =
        research?.content?.map(item => {
            return item?.properties
        }).filter(item => item?.title?.toLowerCase() == "contact us")[0]

    const list = [
        {
            title: "Research Institutes",
            subItems:
                data?.map((item, index) => (
                    {
                        index: index,
                        name: item?.title,
                    }
                ))
        },

    ]
    const contents = data != null ? [
        ...data.map((item, index) => (
            <Content {...item} key={index} />
        ))
    ]: [];




    return (
        <Pages text={text} bg={bg} list={list} contactUs={contactUs?.richTextContent} contents={contents} />
    )
}

export default Irmc